import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import Box from '@material-ui/core/Box';
import { Card } from '@material-ui/core';
import { colors } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List'; 
import ListItem from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Link from '@material-ui/core/Link';
import NotificationsIcon from '@material-ui/icons/Notifications';
import { mainListItems, SecondaryListItems } from '../listItems';
import { useSelector, useDispatch } from "react-redux"
import { Button } from '@material-ui/core';
import logo5 from "../../logo5.png";
import RehabPlanMainComponent from '../data/overview_data.js/RehabPlanMainComponent';
import Treatmentadvices from '../data/treatmentadvice/Treatmentadvice.js';
import recoveryPhases from '../data/recoveryPhases';
import * as AuthActions from "../../../store/actions/auth";
import ReactPlayer from 'react-player';
import RehabPhases from "../data/rehabPhases.js";
import HorizontalScroll from 'react-horizontal-scrolling';
import Skeleton from '@material-ui/lab/Skeleton';
import VideoPlayer from "./videoPlayer";
import NextExercises from "./nextExersices";
//import FeedbackComp from "./feedback";
import FeedbackCompPopOver from "./popoverFeedback";
import FeedbackDialog from "./dialogbox";
import LinearProgress from "@material-ui/core/LinearProgress";
import WeeklyGoal from '../data/overview_data.js/WeeklyGoal';
import CompletedExercises from './completedExersices';
import CurrentSessionTracker from "../data/overview_data.js/CurrentSessionTracker";
import VideoTutorial from "./YTtutorial";
import RehabPhaseTracker from '../data/overview_data.js/RehabPhaseTracker';
import screenfull from "screenfull";
import HowItWorksAccordion from "./accordionHowItWorks";
import DateRangeIcon from '@material-ui/icons/DateRange';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import DiscreteSlider from "./rehabPhaseProgressBar";

const useStyles = makeStyles(() => ({
  root: {
    height: '100%'
  },
  avatar: {
    backgroundColor: colors.orange[600],
    height: 50,
    width: 50
  }
}));

const WelcomeScreenPreparationText = (props) => {
  const className = props.className

  const classes = useStyles();
  const [feedbackRef, setFeedbackRef] = useState()
  const containerRef = React.useRef()
  const playerRef = React.useRef()

  const [anchorEl, setAnchorEl] = React.useState(null);

  const [videoDuration, setVideoDuration] = React.useState(null);

  const [diagnosis, setDiagnosis] = useState({
    title: "",
    explainer: "",
    identifier: ""
  }) // Placeholder
  const { innerWidth: width, innerHeight: height } = window;

  const [token, _] = useState(useSelector(state => state.auth.token))
  const [exercises, setExercises] = useState([])
  const [current_exercise_ind, setCurrent_exercise_ind] = useState(0)

  //feedback, start or video
  const [playingState, setPlayingState] = useState("video")

  const simpleFormatter = (text, len) => {
    var i = 0;
    for (i = 0; i < text.length; i = i + len) {
      if (i != 0) {
        const subString = text.slice(0, i).split("").reverse().join(""); // abc d -> d cba
        const splitIndex = subString.length - subString.indexOf(' ');
        text = text.slice(0, splitIndex) + "\n" + text.slice(splitIndex);
      }
    }
    return text;
  }

  const fetchDiagnosisData = async () => {
    const response = await fetch("https://api.virtus-one.com/treatment/diagnosis/", {
      headers: {
        "Authorization": `Token ${token}`
      },
      method: "GET",
    });

    if (response.ok) {
      const data = await response.json();
      // console.log(data)
      setDiagnosis({...data[0].diagnosis})
      console.log("First me")
      fetchExercises(data[0].diagnosis)

    } else {
      alert("ERROR")
    }
  }
  
  
  const fetchExercises = async (__diagnosis) => {
    console.log("Then me")
    const response = await fetch("https://api.virtus-one.com/treatment/session/today/" + __diagnosis.identifier, {
      headers: {
        "Authorization": `Token ${token}`
      },
      method: "GET",
    });
    
    if (response.ok) {
      const data = await response.json();
      setExercises(data["exercises"])
      
      
    } else {
      alert("ERROR")
    }
  }
  
  const handleStateShift = (newState) => {
    console.log(newState)
    setPlayingState(newState)
  }
  
  useEffect(async () => {
    fetchDiagnosisData()
    
  }, [])

  const toggleFullScreen = () => {
    screenfull.toggle(containerRef.current)
  }

  const onFeedbackConfirm = () => {
    setCurrent_exercise_ind(current => current + 1)
    playerRef.current.restart()
  }


  return (
    <div className={classes.root}>
      <Grid container direction="row">
      {/*<Grid item style={{width: "100%", marginLeft: 1, marginRight: 1, marginBottom: 15}}>
            <HowItWorksAccordion/>
          </Grid>*/}
       

        <Grid container xs={12} direction="row" style={{ marginTop: 0 }}>
          <Grid item xs={5} style={{marginTop: 10}}>
          <Typography >
          Here is an overview of your physiotherapy plan, and your next planned session.
          <br/> <br/> Start by preparing the equipment needed for your exercises.
          <br/> <br/>You will need: <list>
              <br/>*<br/>*<br/>*<br/>
            </list>
          </Typography>
          <Typography >
          Then watch the short video introduction of the planned exercises for this session by clicking on the play icon for each exercise.
          <br/>When you are ready, begin your exercises by clicking the "Begin" session button to the right.
          <br/>You can broadcast to bigger screen if want or simply train along watching the screen of your smartphone, tablet, laptop or stationary computer. 
          <br/>In general no warm-up is required. You can train along from the beginning of the session.
          <br/>You can always pause or restart your program if you need to, however it is not possible to fast forward or skip the exercises, as our algorithm tracks your compliance with the program.
          <br/>If you need to stop the exercise, press the alert notification icon in the upper right corner and provide feedback for the exercise. 
          <br/><br/>If you need further assistance you can always book a consultation with one of our physiotherapists.
          <br/>Click the calendar icon to open our booking system<IconButton><DateRangeIcon style={{marginTop: 0, marginBottom: 2, color: "#002D55"}}></DateRangeIcon> </IconButton>
          </Typography>
          </Grid>
          <Grid container xs={12} direction="row" style={{ marginTop: 0 }}>
          <Grid item xs={12} style={{ marginTop: "2%", marginLeft: 18, marginBottom: 5 }}>
            <IconButton style={{marginRight: 10}}><PlayCircleOutlineIcon style={{marginRight: 0, marginTop: 0, marginBottom: 0, color: "#002D55", scale: "2.5"}}></PlayCircleOutlineIcon> </IconButton>
            <Typography color="textSecondary" variant="h7">
              Click the 'Play' icon to begin your planned session. 
              </Typography>
          </Grid>
          <Grid item xs={12}>
            <NextExercises
              nextExercises={exercises}
            />
          </Grid>
        </Grid>
        </Grid>

      </Grid>
    </div>
  );
};


export default WelcomeScreenPreparationText;
